import { VIEWER_MODES } from 'constants/all';

import { isAuthenticated } from 'modules/common/permissions';

import ViewerPage from '../entry';
import { initPartLibraryViewer } from './sagas';

export const partViewerRoutePrefix = `/parts/${VIEWER_MODES.OWNER}`; //partViewerRoutePrefix === '/parts/viewer'

export default [
  {
    component: ViewerPage,
    exact: true,
    path: '/parts/:mode/:partMasterUUID/',
    helpId: 'viewer',
    permissions: [isAuthenticated],
    saga: initPartLibraryViewer,
  },
];
